// src/config/firebaseConfig.js
// Reads Firebase config from environment variables (Create React App prefix REACT_APP_)
// Falls back to legacy inline config if env vars are not provided.

const legacyConfig = {
  apiKey: "AIzaSyAqkiIXLHW1jpUZhnNQYyZ-Vsmr9HnW0BI",
  authDomain: "vmsc-school-portal-94f16.firebaseapp.com",
  projectId: "vmsc-school-portal-94f16",
  storageBucket: "vmsc-school-portal-94f16.appspot.com",
  messagingSenderId: "380676951077",
  appId: "1:380676951077:web:beff927c8c74deabb283cc",
  measurementId: "G-WMDJLP8H3F"
};

function getEnvConfig() {
  return {
    apiKey: process.env.REACT_APP_FB_API_KEY,
    authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FB_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FB_APP_ID,
    measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID
  };
}

export function getFirebaseConfig() {
  const envCfg = getEnvConfig();
  const hasAll =
    !!envCfg.apiKey &&
    !!envCfg.authDomain &&
    !!envCfg.projectId &&
    !!envCfg.storageBucket &&
    !!envCfg.messagingSenderId &&
    !!envCfg.appId;
  return hasAll ? envCfg : legacyConfig;
}

// Toggle for localStorage fallbacks. In production set REACT_APP_USE_LOCAL_FALLBACK=false
let useLocal = String(process.env.REACT_APP_USE_LOCAL_FALLBACK || "true").toLowerCase() !== "false";
try {
  const override = localStorage.getItem("forceFirestore");
  if (typeof override !== "undefined" && override !== null) {
    const forceFs = String(override).toLowerCase() === "true";
    if (forceFs) useLocal = false;
  }
} catch {
  // ignore
}
export const USE_LOCAL_FALLBACK = false;

// Include demo students? Defaults to true in development (local fallback), false in production.
export const INCLUDE_DEMO_STUDENTS =
  String(process.env.REACT_APP_INCLUDE_DEMO_STUDENTS ?? (USE_LOCAL_FALLBACK ? "true" : "false")).toLowerCase() !== "false";
